<template>
<div>
	<div class="flex py-2 m-2 px-4">
		<div class="flex-1 text-left">
			<p class="text-lg font-extrabold">Välj provtagning</p> 
			<p class="text-md font-light mt-2" v-text="customer.id + ' ' + customer.title"></p>
		</div>
		<div class="flex-1">
			<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
				<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
			</button>
		</div>
	</div>

	<div class="max-h-screen-50 py-4 overflow-scroll">
		<div class="mb-4 mx-12">
			<div class="flex flex-wrap h-full">

				<div v-for="sampling in samplings" :key="sampling.customer_id + '-' + sampling.year" class="w-1/3 mb-4">
					<div class="max-w-xs bg-white rounded overflow-hidden shadow-md pt-1">
						<div class="px-2 py-4">
							<div class="font-bold text-xl mb-2" v-text="sampling.year"></div>
							<div class="flex justify-center justify-between">
								<div class="text-left ml-12">
									<div class="mb-3">
										<p class="inline font-bold" v-text="sampling.antal_prover"></p>
										<p class="inline"> prover</p>
									</div>
									<div class="mb-2" v-for="analysis in sampling.analyses" :key="analysis.title">
										<span :class="[analysis.value ? 'bg-green' : 'bg-grey', 'inline-block rounded-full w-2 h-2']" style="margin-bottom:0.12rem"></span> 
										<p class="inline ml-3" v-text="analysis.title"></p>
									</div>
								</div>
							</div>
						</div>
						<button class="w-full bg-blue py-2 hover:bg-blue-dark" @click="selectYear(sampling.year)">
							<p class="text-white font-semibold">
								Gå till kartan
								<svg class="h-3 w-3 ml-1 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/></svg>
							</p>
						</button>
					</div>
				</div>

			</div>
		</div>
	</div>

	<div class="w-full bg-grey-lightish rounded-b pb-16">
		<div class="float-left flex ml-4 mt-4">
			<button @click="goBack()" class="items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white block bg-grey-dark hover:bg-grey-darker rounded shadow-light font-bold">
				<svg class="text-white fill-current w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>
				Gå tillbaka
			</button>
			<button v-if="user.region.id === 1" @click="chooseOrder()" class="ml-3 flex items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white bg-blue hover:bg-blue-dark rounded shadow-light font-bold">
				<svg class="mr-2 fill-current h-5 w-5 text-gray-500 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150" viewBox="0 0 512 512">
					<g fill="currentColor"><path d="m203.886719 422.871094 145.910156-29.132813 6.265625 31.378907-145.910156 29.132812zm0 0"></path><path d="m393.71875 349.832031 29.132812-145.914062 31.378907 6.265625-29.132813 145.914062zm0 0"></path><path d="m246.507812 96.621094 11.894532-29.707032 151.039062 60.476563-11.894531 29.707031zm0 0"></path><path d="m84.117188 177.589844 80.003906-88.636719 23.753906 21.4375-80.003906 88.636719zm0 0"></path><path d="m68.179688 274.460938 29.40625-12.621094 58.238281 135.6875-29.40625 12.621094zm0 0"></path></g><path d="M 255.573 64.314 C 255.573 91.425 233.598 113.4 206.487 113.4 C 179.376 113.4 157.4 91.425 157.4 64.314 C 157.4 37.203 179.376 15.227 206.487 15.227 C 233.598 15.227 255.573 37.203 255.573 64.314 Z M 255.573 64.314" fill="none" stroke="currentColor" stroke-width="25"></path><path d="M 492.348 158.597 C 492.348 185.708 470.373 207.683 443.262 207.683 C 416.151 207.683 394.175 185.708 394.175 158.597 C 394.175 131.486 416.151 109.51 443.262 109.51 C 470.373 109.51 492.348 131.486 492.348 158.597 Z M 492.348 158.597" fill="none" stroke="currentColor" stroke-width="25"></path><path d="M 112.331 224.484 C 112.331 251.595 90.356 273.57 63.245 273.57 C 36.134 273.57 14.158 251.595 14.158 224.484 C 14.158 197.373 36.134 175.397 63.245 175.397 C 90.356 175.397 112.331 197.373 112.331 224.484 Z M 112.331 224.484" fill="none" stroke="currentColor" stroke-width="25"></path><path d="M 209.981 439.693 C 209.981 466.804 188.006 488.779 160.895 488.779 C 133.784 488.779 111.808 466.804 111.808 439.693 C 111.808 412.582 133.784 390.606 160.895 390.606 C 188.006 390.606 209.981 412.582 209.981 439.693 Z M 209.981 439.693" fill="none" stroke="currentColor" stroke-width="25"></path><path d="M 446.417 398.265 C 446.417 425.376 424.442 447.351 397.331 447.351 C 370.22 447.351 348.244 425.376 348.244 398.265 C 348.244 371.154 370.22 349.178 397.331 349.178 C 424.442 349.178 446.417 371.154 446.417 398.265 Z M 446.417 398.265" fill="none" stroke="currentColor" stroke-width="25"></path>
				</svg>
				Välj samlingsprov från order
			</button>
		</div>
	</div>
</div>
</template>

<script>

import axios from 'axios'

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			samplings: [],
		}
	},

	computed: {

		...mapGetters({
			customer:		'customer/customer',
			user:			'auth/user',
		}),

	},

	mounted() {
		this.fetchSamplings()
	},

	methods: {

		fetchSamplings() {
			axios.get('/customer/' + this.customer.id + '/allwithanalyses')
			.then(response => {
				this.samplings = response.data.map(sampling => {
					return {
						antal_prover: sampling.antal_prover,
						max_provnr: sampling.max_provnr,
						min_provnr: sampling.min_provnr,
						year: sampling.year,
						analyses: [
							{ title: "Grundanalys", value: sampling.num_ph },
							{ title: "Lerhalt", value: sampling.num_lerhalt },
							{ title: "Förrådsanalys", value: sampling.num_p_hcl + sampling.num_k_hcl + sampling.num_cu_hcl + sampling.num_bor },
							{ title: "Kadmium", value: sampling.num_cd_hno3 },
							{ title: "Tungmetall", value: sampling.num_tungmetall },
						],
					}
				})
			})

		},

		selectYear(year) {
			this.$store.dispatch("customer/SET_YEAR", year)
		},

		goBack() {
			this.$store.dispatch("customer/CLEAR_CUSTOMER")
		},

		chooseOrder() {
			this.$emit('selectOrder')
		},

		dismissModal() {
			this.$emit('closeModal')
		}

	}
}
</script>